export const handleDownload = async (recordingUrl) => {
  const response = await fetch(recordingUrl)
  const contentType = response.headers.get('Content-Type')
  const fileName = recordingUrl.split('Recordings/')[1] || 'recording'
  const fileType = contentType === 'audio/x-wav' ? 'wav' : 'mp3'

  const blob = await response.blob()
  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = `${fileName}.${fileType}`
  document.body.appendChild(link)
  link.click()

  window.URL.revokeObjectURL(url)
  document.body.removeChild(link)
}

export const formatTime = (time) => {
  const minutes = Math.floor(time / 60)
  const seconds = Math.floor(time % 60)
  return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
}
